import { render } from "./Specialties.vue?vue&type=template&id=ff59adae"
import script from "./Specialties.vue?vue&type=script&lang=js"
export * from "./Specialties.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__